export interface ProductModelGroup {
  label: string;
  models: string[];
}

export const DEFAULT_PHONE_MODEL_GROUPS: ProductModelGroup[] = [
  {
    label: "iPhone",
    models: [
      "iPhone Ultra", "iPhone 18 Pro Max", "iPhone 18 Pro",
      "iPhone 17 Pro Max", "iPhone 17 Pro", "iPhone 17 Air", "iPhone 17",
      "iPhone 16 Pro Max", "iPhone 16 Pro", "iPhone 16 Plus", "iPhone 16",
      "iPhone 15 Pro Max", "iPhone 15 Pro", "iPhone 15 Plus", "iPhone 15",
      "iPhone 14 Pro Max", "iPhone 14 Pro", "iPhone 14 Plus", "iPhone 14",
      "iPhone 13 Pro Max", "iPhone 13 Pro", "iPhone 13", "iPhone 13 Mini",
      "iPhone 12 Pro Max", "iPhone 12 Pro", "iPhone 12", "iPhone 12 Mini",
      "iPhone 11 Pro Max", "iPhone 11 Pro", "iPhone 11",
    ],
  },
  {
    label: "Samsung Galaxy S",
    models: [
      "Samsung Galaxy S25 Ultra", "Samsung Galaxy S25+", "Samsung Galaxy S25",
      "Samsung Galaxy S24 Ultra", "Samsung Galaxy S24+", "Samsung Galaxy S24",
      "Samsung Galaxy S23 Ultra", "Samsung Galaxy S23+", "Samsung Galaxy S23",
      "Samsung Galaxy S22 Ultra", "Samsung Galaxy S22+", "Samsung Galaxy S22",
      "Samsung Galaxy S21 Ultra", "Samsung Galaxy S21+", "Samsung Galaxy S21",
    ],
  },
  {
    label: "Samsung Galaxy A",
    models: [
      "Samsung Galaxy A55", "Samsung Galaxy A35", "Samsung Galaxy A25",
      "Samsung Galaxy A15", "Samsung Galaxy A05",
    ],
  },
  {
    label: "Google Pixel",
    models: [
      "Google Pixel 10 Pro XL", "Google Pixel 10 Pro", "Google Pixel 10",
      "Google Pixel 9 Pro Fold", "Google Pixel 9 Pro XL", "Google Pixel 9 Pro", "Google Pixel 9", "Google Pixel 9a",
      "Google Pixel 8 Pro", "Google Pixel 8", "Google Pixel 8a",
      "Google Pixel 7 Pro", "Google Pixel 7", "Google Pixel 7a",
      "Google Pixel Fold",
      "Google Pixel 6 Pro", "Google Pixel 6", "Google Pixel 6a",
    ],
  },
];

export const DEFAULT_LAPTOP_MODEL_GROUPS: ProductModelGroup[] = [
  {
    label: "MacBook Pro",
    models: [
      'MacBook Pro 16" (M4 Pro/Max, 2024)',
      'MacBook Pro 16" (M3 Pro/Max, 2023)',
      'MacBook Pro 16" (M2 Pro/Max, 2023)',
      'MacBook Pro 16" (M1 Pro/Max, 2021)',
      'MacBook Pro 14" (M4 / Pro / Max, 2024)',
      'MacBook Pro 14" (M3 / Pro / Max, 2023)',
      'MacBook Pro 14" (M2 Pro/Max, 2023)',
      'MacBook Pro 14" (M1 Pro/Max, 2021)',
      'MacBook Pro 13" (M2, 2022)',
      'MacBook Pro 13" (M1, 2020)',
    ],
  },
  {
    label: "MacBook Air",
    models: [
      'MacBook Air 15" (M4, 2025)',
      'MacBook Air 15" (M3, 2024)',
      'MacBook Air 15" (M2, 2023)',
      'MacBook Air 13" (M4, 2025)',
      'MacBook Air 13" (M3, 2024)',
      'MacBook Air 13" (M2, 2022)',
      'MacBook Air 13" (M1, 2020)',
    ],
  },
  {
    label: "Dell",
    models: [
      'Dell XPS 13 (9340, 2024)',
      'Dell XPS 13 (9315, 2022)',
      'Dell XPS 14 (9440, 2024)',
      'Dell XPS 15 (9530, 2023)',
      'Dell XPS 16 (9640, 2024)',
      'Dell Inspiron 14',
      'Dell Inspiron 15',
      'Dell Latitude 7440',
    ],
  },
  {
    label: "Lenovo",
    models: [
      'Lenovo ThinkPad X1 Carbon Gen 12',
      'Lenovo ThinkPad X1 Carbon Gen 11',
      'Lenovo ThinkPad T14',
      'Lenovo Yoga Slim 7',
      'Lenovo Yoga 9i 14"',
      'Lenovo Legion 5 Pro 16"',
      'Lenovo IdeaPad Slim 5',
    ],
  },
  {
    label: "Samsung",
    models: [
      'Samsung Galaxy Book4 Ultra 16"',
      'Samsung Galaxy Book4 Pro 16"',
      'Samsung Galaxy Book4 Pro 14"',
      'Samsung Galaxy Book4 360',
      'Samsung Galaxy Book3 Pro 16"',
      'Samsung Galaxy Book3 Pro 14"',
    ],
  },
  {
    label: "HP",
    models: [
      'HP Spectre x360 14"',
      'HP Spectre x360 16"',
      'HP Envy 14',
      'HP Pavilion 15',
      'HP EliteBook 840 G11',
      'HP Omen 16',
    ],
  },
  {
    label: "ASUS",
    models: [
      'ASUS Zenbook 14 OLED',
      'ASUS Zenbook 15 OLED',
      'ASUS Zenbook Duo (2024)',
      'ASUS ROG Zephyrus G14 (2024)',
      'ASUS ROG Zephyrus G16 (2024)',
      'ASUS Vivobook 15',
    ],
  },
  {
    label: "Microsoft Surface",
    models: [
      'Surface Laptop 7 13.8"',
      'Surface Laptop 7 15"',
      'Surface Laptop 6 13.5"',
      'Surface Laptop 6 15"',
      'Surface Laptop Studio 2',
      'Surface Pro 11',
    ],
  },
  {
    label: "Razer",
    models: [
      'Razer Blade 14 (2024)',
      'Razer Blade 15',
      'Razer Blade 16 (2024)',
      'Razer Blade 18 (2024)',
    ],
  },
  {
    label: "Acer",
    models: [
      'Acer Swift Go 14',
      'Acer Swift X 14',
      'Acer Aspire 5',
      'Acer Predator Helios 16',
    ],
  },
];

export interface ProductModelLists {
  phones: ProductModelGroup[];
  laptops: ProductModelGroup[];
  tablets: ProductModelGroup[];
  consoles?: ProductModelGroup[];
  controllers?: ProductModelGroup[];
  cameras?: ProductModelGroup[];
  lenses?: ProductModelGroup[];
}

export const DEFAULT_TABLET_MODEL_GROUPS: ProductModelGroup[] = [
  {
    label: "iPad Pro",
    models: [
      'iPad Pro 13" (M4, 2024)',
      'iPad Pro 11" (M4, 2024)',
      'iPad Pro 12.9" (M2, 2022)',
      'iPad Pro 11" (M2, 2022)',
      'iPad Pro 12.9" (M1, 2021)',
      'iPad Pro 11" (M1, 2021)',
    ],
  },
  {
    label: "iPad Air",
    models: [
      'iPad Air 13" (M2, 2024)',
      'iPad Air 11" (M2, 2024)',
      'iPad Air 5 (M1, 2022)',
      'iPad Air 4 (2020)',
    ],
  },
  {
    label: "iPad / iPad mini",
    models: [
      'iPad 10th Gen (2022)',
      'iPad 9th Gen (2021)',
      'iPad mini 7 (A17 Pro, 2024)',
      'iPad mini 6 (2021)',
    ],
  },
  {
    label: "Samsung Galaxy Tab",
    models: [
      'Galaxy Tab S10 Ultra',
      'Galaxy Tab S10+',
      'Galaxy Tab S9 Ultra',
      'Galaxy Tab S9+',
      'Galaxy Tab S9',
      'Galaxy Tab S9 FE+',
      'Galaxy Tab S9 FE',
      'Galaxy Tab S8 Ultra',
      'Galaxy Tab S8+',
      'Galaxy Tab S8',
      'Galaxy Tab A9+',
      'Galaxy Tab A9',
    ],
  },
  {
    label: "Microsoft Surface",
    models: [
      'Surface Pro 11',
      'Surface Pro 10',
      'Surface Pro 9',
      'Surface Pro 8',
      'Surface Go 4',
      'Surface Go 3',
    ],
  },
  {
    label: "Xiaomi",
    models: [
      'Xiaomi Pad 6S Pro',
      'Xiaomi Pad 6 Pro',
      'Xiaomi Pad 6',
      'Redmi Pad Pro',
      'Redmi Pad SE',
    ],
  },
  {
    label: "Huawei / Honor / Lenovo",
    models: [
      'Huawei MatePad Pro 13.2"',
      'Huawei MatePad Pro 11"',
      'Huawei MatePad 11.5"',
      'Honor Pad 9',
      'Lenovo Tab P12',
      'Lenovo Tab P11 Pro',
    ],
  },
  {
    label: "OnePlus / Google",
    models: [
      'OnePlus Pad 2',
      'OnePlus Pad',
      'Google Pixel Tablet',
    ],
  },
];

export const DEFAULT_PRODUCT_MODEL_LISTS: ProductModelLists = {
  phones: DEFAULT_PHONE_MODEL_GROUPS,
  laptops: DEFAULT_LAPTOP_MODEL_GROUPS,
  tablets: DEFAULT_TABLET_MODEL_GROUPS,
  consoles: [
    {
      label: "PlayStation",
      models: [
        "PlayStation 5 (Standard)",
        "PlayStation 5 (Digital Edition)",
        "PlayStation 5 Slim (Disc)",
        "PlayStation 5 Slim (Digital)",
        "PlayStation 5 Pro",
        "PlayStation 4 (Original)",
        "PlayStation 4 Slim",
        "PlayStation 4 Pro",
      ],
    },
    {
      label: "Xbox",
      models: [
        "Xbox Series X",
        "Xbox Series S",
        "Xbox One X",
        "Xbox One S",
        "Xbox One (Original)",
      ],
    },
    {
      label: "Nintendo Switch",
      models: [
        "Nintendo Switch 2",
        "Nintendo Switch OLED",
        "Nintendo Switch (V2, 2019)",
        "Nintendo Switch (Original, 2017)",
        "Nintendo Switch Lite",
      ],
    },
    {
      label: "Steam Deck / ROG Ally",
      models: [
        "Steam Deck OLED",
        "Steam Deck LCD",
        "ASUS ROG Ally X",
        "ASUS ROG Ally",
      ],
    },
  ],
  controllers: [
    {
      label: "PlayStation",
      models: [
        "DualSense (PS5)",
        "DualSense Edge (PS5)",
        "DualShock 4 (PS4)",
      ],
    },
    {
      label: "Xbox",
      models: [
        "Xbox Wireless Controller (Series X|S)",
        "Xbox Elite Wireless Controller Series 2",
        "Xbox One Controller",
      ],
    },
    {
      label: "Nintendo",
      models: [
        "Nintendo Switch Pro Controller",
        "Joy-Con Pair (Switch)",
        "Joy-Con Pair (Switch 2)",
      ],
    },
  ],
  cameras: [
    {
      label: "Canon",
      models: [
        "Canon EOS R5 Mark II",
        "Canon EOS R6 Mark II",
        "Canon EOS R6",
        "Canon EOS R5",
        "Canon EOS R7",
        "Canon EOS R8",
        "Canon EOS R10",
        "Canon EOS R50",
      ],
    },
    {
      label: "Sony",
      models: [
        "Sony A7 IV",
        "Sony A7R V",
        "Sony A7C II",
        "Sony A7S III",
        "Sony A6700",
        "Sony ZV-E10",
        "Sony ZV-1",
      ],
    },
    {
      label: "Nikon",
      models: [
        "Nikon Z9",
        "Nikon Z8",
        "Nikon Z6 III",
        "Nikon Z6 II",
        "Nikon Z5",
        "Nikon Zf",
        "Nikon Zfc",
      ],
    },
    {
      label: "Fujifilm",
      models: [
        "Fujifilm X-T5",
        "Fujifilm X-T4",
        "Fujifilm X-S20",
        "Fujifilm X-H2",
        "Fujifilm X100VI",
      ],
    },
  ],
  lenses: [
    {
      label: "Canon RF",
      models: [
        "Canon RF 85mm F1.2L USM",
        "Canon RF 24mm F1.8 Macro IS STM",
        "Canon RF 16mm F2.8 STM",
        "Canon RF 24-70mm F2.8L IS USM",
        "Canon RF 70-200mm F2.8L IS USM",
        "Canon RF 50mm F1.2L USM",
      ],
    },
    {
      label: "Sony E",
      models: [
        "Sony FE 24-70mm F2.8 GM II",
        "Sony FE 70-200mm F2.8 GM OSS II",
        "Sony FE 85mm F1.4 GM II",
        "Sony FE 50mm F1.2 GM",
      ],
    },
    {
      label: "Nikon Z",
      models: [
        "Nikon NIKKOR Z 24-70mm f/2.8 S",
        "Nikon NIKKOR Z 70-200mm f/2.8 VR S",
        "Nikon NIKKOR Z 85mm f/1.2 S",
        "Nikon NIKKOR Z 50mm f/1.2 S",
      ],
    },
  ],
};